import React, { useRef, useState } from "react";
import TreatmentPlanCard from "./TreatmentPlanCard";
import HorizontalScrollWrapper from "../common/HorizontalScrollWrapper";
import InfoIcon from "../../svg/InfoIcon";
import useTheme from "../../../../common/hooks/useTheme";
import { treatmentPlanTableType } from "../../../../providers/dataPlatformReportTypes";
import {
  ServicesPage,
  ServiceContent,
} from "../../../new-reports/types/newReportTypes";
import ServiceViewModal from "./ServiceViewModal";

const ServiceContainer = ({
  data,
  title,
}: {
  data: ServicesPage | undefined;
  title: string;
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [selectedService, setSelectedService] = useState<ServiceContent | null>(
    null
  );
  const [modalOpen, setModalOpen] = useState(false);

  const handleCardClick = (service: ServiceContent) => {
    setSelectedService(service);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedService(null);
  };

  if (!data) {
    return null;
  }

  return (
    <div style={{ marginBottom: "24px" }}>
      <HorizontalScrollWrapper
        title={title}
        cardRefs={cardRefs}
        containerRef={containerRef}
        customTitleStyles={{
          fontSize: "16px",
          fontFamily: "var(--font-Regular)",
          marginBottom: "16px",
        }}
      >
        {data.services.map((item, index: number) => (
          <TreatmentPlanCard
            cardRef={(el: any) => (cardRefs.current[index] = el)}
            service={item}
            key={index}
            onClick={() => handleCardClick(item)}
          />
        ))}
      </HorizontalScrollWrapper>

      <ServiceViewModal
        open={modalOpen}
        onClose={handleCloseModal}
        service={selectedService}
        labels={data.labels}
        unitType={data.unitType}
      />
    </div>
  );
};

export default ServiceContainer;
